import React from 'react';
import { Table, TableHeader, TableHead, TableRow, TableBody, TableCell, useTableSort } from '@rotaryintl/harris-table-v4';
import Icons from '@rotaryintl/harris-icons';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const templateIds = {
  headerRow: '15617db7-d339-43c7-86a6-59f2eafc30f4',
  bodyRow: '5ac37bdb-15e4-43fd-a94e-b1f05092b72f',
};

const TableComponent = ({ fields: { children: Rows, HeaderVariant, BodyVariant } }) => {
  const headerRow = Rows?.find((row) => row.templateId === templateIds.headerRow);
  const bodyRows = Rows?.filter((row) => row.templateId === templateIds.bodyRow) || [];
  const headerVariant = HeaderVariant?.value || 'light';
  const bodyVariant = BodyVariant?.value || 'default';
  const isSticky = headerRow?.fields.StickyHeader?.value;
  const isSortingEnabled = headerRow?.fields.EnableSorting?.value;

  const columns = headerRow?.fields?.children?.map((child) => child.fields?.Text?.value ?? '') || [];

  const tableData = bodyRows.map((row) => {
    const cells = row.fields?.children || [];
    const rowData = {};
    cells.forEach((cell, i) => {
      const rawColumn = columns[i] || `Column ${i + 1}`;
      const columnKey = typeof rawColumn === 'string' ? rawColumn.trim() : rawColumn;
      const cellValue = cell.fields?.Text?.value ?? '';
      const cleanValue = cellValue.replace(/[^0-9.\-]/g, '');
      const numValue = parseFloat(cleanValue);
      if (!isNaN(numValue) && cleanValue.trim() !== '') {
        rowData[columnKey] = numValue;
        rowData[`${columnKey}__display`] = cellValue;
      } else if (typeof cellValue === 'string' && cellValue.trim() !== '') {
        rowData[columnKey] = cellValue.trim().charAt(0).toLowerCase();
        rowData[`${columnKey}__display`] = cellValue;
      } else {
        rowData[columnKey] = cellValue;
      }
    });
    return rowData;
  });

  const { sortedData, sortColumn, sortDirection, handleSort } = useTableSort(tableData);

  return (
    <div>
      <Table>
        {headerRow && (
          <TableHeader variant={headerVariant}>
            <TableRow>
              {columns.map((colName, index) => (
                <TableHead
                  stickyHeader={isSticky}
                  key={`header-${index}`}
                  onClick={isSortingEnabled ? () => handleSort(colName) : undefined}
                  style={{ cursor: isSortingEnabled ? 'pointer' : 'default' }}
                >
                  {isSortingEnabled ? (
                    <button type="button" className="cell-label" onClick={() => handleSort(colName)}>
                      <Icons
                        icon={
                          sortColumn === colName
                            ? sortDirection === 'asc'
                              ? 'icon-arrows-caret-up'
                              : sortDirection === 'desc'
                              ? 'icon-arrows-caret-down'
                              : 'icon-filters-sort'
                            : 'icon-filters-sort'
                        }
                      />
                      <span>{colName} </span>
                    </button>
                  ) : (
                    <span style={{ whiteSpace: 'normal' }}>{colName} </span>
                  )}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
        )}

        <TableBody variant={bodyVariant}>
          {sortedData.map((rowData, rowIndex) => (
            <TableRow key={`body-row-${rowIndex}`}>
              {columns.map((colName, cellIndex) => (
                <TableCell className="whitespace-normal border-none" style={{ fontWeight: '400' }} key={`cell-${rowIndex}-${cellIndex}`}>
                  <span className="mobile-header">{colName}: </span>
                  {rowData[`${colName}__display`] ?? rowData[colName]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default withSitecoreContext()(TableComponent);
